import { LogoContainer, NavbarContainer, StyledTab, TabContainer, UserMenuWrapper } from "./styles";
import React, { useEffect, useRef, useState } from "react";
import { COLORS } from "../../../values/colors";
import { useNavigate, useLocation } from "react-router-dom";
import BurgerMenu from "./BurgerMenu/BurgerMenu";
import UserMenu from "./UserMenu";

const Navbar = () => {
    const [value, setValue] = React.useState(2);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);
    const navigate = useNavigate();
    const navbarRef = useRef<HTMLDivElement | null>(null);
    const location = useLocation();

      const handleShopClick = () => {
        if (location.pathname.startsWith("/shop")) {
            navigate("/shop");
            return;
        }

        window.open("/shop", "_blank", "noopener,noreferrer");
    };

    useEffect(() => {
        const path = location.pathname;
        switch (path) {
            case "/ueber-uns":
                setValue(0);
                break;
            case "/die-geschichte":
                setValue(1);
                break;
            case "/die-aeltesten":
                setValue(2);
                break;
            case "/hexenwerkstatt":
                setValue(4);
                break;
            case "/kontakt":
                setValue(5)
                break;
            case "/shop":
                handleShopClick();
                break;
            default:
                setValue(3);
                break;
        }
    }, [location]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1200);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (navbarRef.current) {
                if (window.scrollY > 0) {
                    navbarRef.current.style.transition = 'background-color 0.8s ease';
                    navbarRef.current.style.backgroundColor = 'black';
                } else {
                    navbarRef.current.style.transition = 'background-color 0.4s ease';
                    navbarRef.current.style.backgroundColor = 'transparent';
                }
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        switch (newValue) {
            case 0:
                navigate("/ueber-uns");
                break;
            case 1:
                navigate("/die-geschichte");
                break;
            case 2:
                navigate("/die-aeltesten");
                break;
            case 4:
                navigate("/hexenwerkstatt");
                break;
            case 5:
                navigate("/kontakt");
                break;
            case 6:
                handleShopClick();
                break;
            default:
                break;
        }
    };

    const handleLogoClick = () => {
        navigate("/");
        setValue(2);
    };

    return (
        <>
            {isMobile ? (
                <BurgerMenu />
            ) : (
                <NavbarContainer ref={navbarRef}>
                    <TabContainer
                        value={value}
                        onChange={handleChange}
                        centered
                        textColor="inherit"
                        TabIndicatorProps={{
                            style: { backgroundColor: 'transparent' },
                        }}
                        sx={{ color: COLORS.white }}
                    >
                        <StyledTab label="Über uns" />
                        <StyledTab label="Die Geschichte" />
                        <StyledTab label="Die Ältesten" />
                        <LogoContainer
                            onClick={handleLogoClick}
                        />
                        <StyledTab label="Hexenwerkstatt" />
                        <StyledTab label="Kontakt" />
                        <StyledTab label="Shop" />
                    </TabContainer>
                    <UserMenuWrapper>
                        <UserMenu />
                    </UserMenuWrapper>
                </NavbarContainer>
            )}
        </>
    );
};

export default Navbar;
